import ProductDetailLayout, {
  ProductDetailProps,
} from '@original/components/ProductDetail'
import ProductDetail from '@original/components/ProductDetail/ProductDetail'
import style from './index.module.less'
import ProductBenefits from './ProductBenefits'
import { splitProductDescription } from './splitProductDescription'
export * from '@original/components/ProductDetail'

const HazetProductDetailLayout: React.FC<ProductDetailProps> = ({
  product,
  variantId,
}) => {
  return (
    <ProductDetailLayout
      product={product}
      variantId={variantId}
      slots={{
        price: () => {
          return (
            <ProductDetail.Price className={style.price} hideAdditionalCosts>
              <ProductDetail.PackagingUnitSwitch />
            </ProductDetail.Price>
          )
        },
        productInformation: () => {
          const { highlightBlock } = splitProductDescription(
            product.description
          )
          return (
            <>
              <ProductDetail.ProductInformation />
              {highlightBlock && (
                <ProductBenefits highlights={highlightBlock} />
              )}
            </>
          )
        },
      }}
    />
  )
}

export default HazetProductDetailLayout
